import React from 'react'
import { StateProvider, useStateValue } from '@State'
import { Toaster } from '@CommonComponents/toast'
import UploadForm from './UploadForm'
import PreviewTable from './PreviewTable'
import reducer from '../reducer'

const AppInner = () => {
  const [currentState] = useStateValue()
  return (
    <>
      <UploadForm />
      {currentState.previewRows.length > 0 && <PreviewTable />}
    </>
  )
}

const App = () => {
  const initialState = {
    csvFile: null,
    description: '',
    source: '',
    invoiceNumber: '',
    previewRows: [],
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <AppInner />
    </StateProvider>
  )
}

export default App
